import type { Property } from 'csstype';
import styled, { css } from 'styled-components';

import { type MarginProps, type PaddingProps, spacing } from '#@/shared/utils/styles';

import { bodyVariants, labelVariants, titleVariants } from './constants';

interface SharedProps extends MarginProps, PaddingProps {
  color?: Property.Color;
  textAlign?: Property.TextAlign;
  textDecorationLine?: Property.TextDecorationLine;
  wrapOnNewline?: boolean;
  as?: React.ElementType;
}

const sharedStyles = css<SharedProps>`
  ${spacing.margin}
  ${spacing.padding}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `}
    ${({ textDecorationLine }) =>
    textDecorationLine &&
    css`
      text-decoration-line: ${textDecorationLine};
    `}
  ${({ wrapOnNewline }) =>
    wrapOnNewline &&
    css`
      white-space: pre-wrap;
    `}
`;

export interface BodyProps extends SharedProps {
  variant?: keyof typeof bodyVariants;
}

export const Body = styled.div<BodyProps>`
  ${sharedStyles}
  ${({ variant }) => bodyVariants[variant ?? 'medium']}
`;

export interface LabelProps extends SharedProps {
  variant?: keyof typeof labelVariants;
}

export const Label = styled.div<LabelProps>`
  ${sharedStyles}
  ${({ variant }) => labelVariants[variant ?? 'medium']}
`;

export interface TitleProps extends SharedProps {
  variant: keyof typeof titleVariants;
}

export const Title = styled.h1<TitleProps>`
  ${sharedStyles}
  ${({ variant }) => titleVariants[variant]}
`;
